import {
  Checkbox,
  Col,
  Dropdown,
  Form,
  FormInstance,
  Menu,
  Radio,
  Row,
  Space,
  Typography,
} from 'antd';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import {
  AbcCurveFormValues,
  ClassificationTypes,
  ReportSourceTypes,
  SituationsType,
  WorkOrderType,
} from '@/core/domain/reports/movements/abcCurve/abcCurve.types';
import { Info } from 'react-feather';
import { CheckboxGroupButtons } from '@/components/_common';
import ReportWorkOrderFilterByDateField from '../WorkOrdersReportForm/ReportWorkOrderFilterByDateField';
import { isAppPortocar } from '@/index';

interface Props {
  form: FormInstance<AbcCurveFormValues>;
}
const MovementAbcCurveReportForm: React.FC<Props> = ({ form }) => {
  const { Title } = Typography;

  const reportSource = Form.useWatch('reportSource', form);

  const isCombinedType = reportSource === ReportSourceTypes.COMBINED;
  const isWorkOrderType = reportSource === ReportSourceTypes.WORK_ORDER;
  const isDirectSaleType = reportSource === ReportSourceTypes.DIRECT_SALE;

  const informative = (
    <Menu mode="vertical" style={{ width: 300 }}>
      <Menu.Item key={1}>
        "Fechado" não existe para Vendas Diretas. Neste caso, será considerado
        como "Autorizado".
      </Menu.Item>
    </Menu>
  );

  const workOrderOptions = [
    {
      label: 'Orçamento',
      value: WorkOrderType.WORK_ORDER,
    },
    {
      label: 'Garantia',
      value: WorkOrderType.WARRANTY,
    },
    {
      label: 'Retorno',
      value: WorkOrderType.RETURN,
    },
    {
      label: isAppPortocar ? 'Interna (Cortesia)' : 'Cortesia',
      value: WorkOrderType.COURTESY,
    },
    {
      label: 'Perda Total',
      value: WorkOrderType.TOTAL_LOSS,
    },
    {
      label: 'Revisão',
      value: WorkOrderType.REVISION,
    },
  ];

  const situationOptions = [
    {
      label: 'Aberto',
      value: SituationsType.OPEN,
    },
    {
      label: 'Autorizado',
      value: SituationsType.AUTHORIZED,
    },
    {
      label: 'Cancelado',
      value: SituationsType.CANCELED,
    },
    {
      label: 'Fechado',
      value: SituationsType.CLOSED,
      style: {
        display: isDirectSaleType ? 'none' : '',
      },
    },
  ];

  return (
    <Form layout="vertical" form={form}>
      <ReportSelectMonthFields
        form={form}
        dateFilter={<ReportWorkOrderFilterByDateField />}
      />

      <Row gutter={[16, 8]}>
        <Col sm={24}>
          <Title level={5}>Fonte de Dados</Title>

          <Form.Item
            name="reportSource"
            noStyle
            initialValue={ReportSourceTypes.COMBINED}
          >
            <Radio.Group optionType="button" buttonStyle="solid" size="large">
              <Radio value={ReportSourceTypes.WORK_ORDER}>Orçamento</Radio>

              <Radio value={ReportSourceTypes.DIRECT_SALE}>Venda Direta</Radio>

              <Radio value={ReportSourceTypes.COMBINED}>Ambos</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col sm={24}>
          <Title level={5}>Classificação</Title>

          <Form.Item
            name="classificationType"
            noStyle
            initialValue={ClassificationTypes.QUANTITY}
          >
            <Radio.Group optionType="button" buttonStyle="solid" size="large">
              <Radio value={ClassificationTypes.VALUE}>Valor</Radio>

              <Radio value={ClassificationTypes.QUANTITY}>Quantidade</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col sm={24}>
          <Title level={5}>Situação</Title>

          <Space align="center">
            <Form.Item
              name="situations"
              noStyle
              initialValue={[SituationsType.OPEN]}
            >
              <CheckboxGroupButtons options={situationOptions} />
            </Form.Item>

            {isCombinedType && (
              <Dropdown
                overlay={informative}
                trigger={['click']}
                arrow
                placement="topCenter"
              >
                <Info size={20} id="note-type-icon" cursor={'pointer'} />
              </Dropdown>
            )}
          </Space>
        </Col>

        {(isWorkOrderType || isCombinedType) && (
          <>
            <Col sm={24}>
              <Title level={5}>Tipo de orçamento</Title>

              <Form.Item
                name="workOrderTypes"
                noStyle
                initialValue={[WorkOrderType.WORK_ORDER]}
              >
                <CheckboxGroupButtons options={workOrderOptions} />
              </Form.Item>
            </Col>

            <Col span={24} md={12} lg={6}>
              <Form.Item
                name="parts"
                initialValue={true}
                valuePropName="checked"
              >
                <Checkbox>Peças</Checkbox>
              </Form.Item>
            </Col>

            <Col span={24} md={12} lg={6}>
              <Form.Item
                name="suppliedParts"
                initialValue={false}
                valuePropName="checked"
              >
                <Checkbox>Peças Fornecidas</Checkbox>
              </Form.Item>
            </Col>

            <Col span={24} md={12} lg={6}>
              <Form.Item
                name="services"
                initialValue={true}
                valuePropName="checked"
              >
                <Checkbox>Serviços</Checkbox>
              </Form.Item>
            </Col>

            <Col span={24} md={12} lg={6}>
              <Form.Item
                name="thirdParty"
                initialValue={false}
                valuePropName="checked"
              >
                <Checkbox>Serviços de Terceiros</Checkbox>
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
    </Form>
  );
};

export default MovementAbcCurveReportForm;
